module.exports = __webpack_public_path__ + "img/accountblock-Rupee-Icon.57a68058.svg";